enum RouteCodes {
  register = "/register",
  migrate = "/migrate",
}

export default RouteCodes;
